<h1 mat-dialog-title>{{'ChangePassword.title' | localize }}</h1>

<div mat-dialog-content>

  <form [formGroup]="changePasswordForm">
    <div class="row">
      <mat-form-field appearance="outline">
        <mat-label>{{'emailID' | localize }}</mat-label>
        <input matInput formControlName="emailId">
        <mat-icon matPrefix color="primary">mail</mat-icon>
      </mat-form-field>
    </div>
    <div class="row">
      <mat-form-field appearance="outline">
        <mat-label>{{'oldPassword' | localize }}</mat-label>
        <input matInput [type]="oldPassHide ? 'password' : 'text'" formControlName="oldPassword">
        <mat-icon matSuffix (click)="oldPassHide = !oldPassHide">{{oldPassHide ? 'visibility_off' :
          'visibility'}}</mat-icon>
        <mat-icon matPrefix color="primary">lock</mat-icon>
        <mat-error *ngIf="changePasswordForm.controls.oldPassword.hasError('required')">{{'ChangePassword.oldPasswordRequired' |
          localize }}</mat-error>
      </mat-form-field>
    </div>
    <div class="row">
      <mat-form-field appearance="outline">
        <mat-label>{{'ChangePassword.newPassword' | localize }}</mat-label>
        <input matInput [type]="newPassHide ? 'password' : 'text'" formControlName="newPassword">
        <mat-icon matSuffix (click)="newPassHide = !newPassHide">{{newPassHide ? 'visibility_off' :
          'visibility'}}</mat-icon>
        <mat-icon matPrefix color="primary">lock</mat-icon>
        <mat-error *ngIf="changePasswordForm.controls.newPassword.hasError('required')">{{'newPasswordRequired' |
          localize }}</mat-error>
        <mat-error *ngIf="changePasswordForm.controls.newPassword.hasError('pattern')">{{'ChangePassword.passwordInvalid' | localize
          }}</mat-error>
      </mat-form-field>
    </div>
    <div class="row">
      <mat-form-field appearance="outline">
        <mat-label>{{'ChangePassword.confirmPassword' | localize }}</mat-label>
        <input matInput [type]="cnfmPassHide ? 'password' : 'text'" formControlName="confirmPassword">
        <mat-icon matSuffix (click)="cnfmPassHide = !cnfmPassHide">{{cnfmPassHide ? 'visibility_off' :
          'visibility'}}</mat-icon>
        <mat-icon matPrefix color="primary">lock</mat-icon>
        <mat-error *ngIf="changePasswordForm.controls.confirmPassword.hasError('required')">{{'ChangePassword.confirmPasswordRequired'
          | localize }}</mat-error>
        <mat-error
          *ngIf="changePasswordForm.controls.confirmPassword.invalid && !changePasswordForm.controls.confirmPassword.hasError('required')">
          {{'ChangePassword.passwordMismatch' | localize }}
        </mat-error>
      </mat-form-field>
    </div>
    <div class="d-flex justify-content-center">
      <button class="submit-button" type="submit" mat-raised-button (click)="submitChangePasswordForm()" [disabled]="!changePasswordForm.valid"
      cdkFocusInitial color="primary">{{'ChangePassword.changePassword' | localize }}</button>
    </div>
    <div class="note">
      <div class="note-label">{{'ChangePassword.Note' | localize }}</div>
      {{'ChangePassword.passwordFormat' | localize }}
    </div>
  </form>
</div>
<div mat-dialog-actions align="end">
  <button mat-raised-button id="closeButton" class="reset_bg" (click)="onDialogCancel()">{{'close' |
    localize }}</button>
</div>
